import { render, staticRenderFns } from "./relatorioDAIR.vue?vue&type=template&id=28f13049"
import script from "./relatorioDAIR.vue?vue&type=script&lang=js"
export * from "./relatorioDAIR.vue?vue&type=script&lang=js"
import style0 from "./relatorioDAIR.vue?vue&type=style&index=0&id=28f13049&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports